import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { SortableColumns } from './-constants';
export const SearchSchema = z.object({
  sortColumn: z.enum(SortableColumns).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional()
});